import React from "react"
import s from "./grid.module.css"

const Grid = () => {
    return <div className={s.wrapper}></div>
}

export default Grid
